import type { SVGProps } from 'react';

interface PagesIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const PagesIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & PagesIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 20 20"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M5.127 4.101 5.125 5.8v8.402c0 .69.257 1.35.714 1.838a2.36 2.36 0 0 0 1.723.761h6.462c-.116.351-.331.655-.616.87s-.626.33-.975.33h-4.87c-.945 0-1.851-.4-2.52-1.113A3.93 3.93 0 0 1 4 14.201V5.799c0-.784.47-1.451 1.127-1.698M14.313 2c.221 0 .44.047.645.137s.391.223.548.39c.156.167.28.366.365.584S16 3.563 16 3.8v10.398c0 .236-.044.47-.129.688-.084.219-.209.417-.365.584-.157.167-.343.3-.548.39-.204.09-.424.137-.646.137h-6.75c-.447 0-.876-.19-1.193-.527a1.86 1.86 0 0 1-.494-1.272V3.8c0-.478.178-.935.494-1.273A1.64 1.64 0 0 1 7.563 2z"
      fill="#fff"
    />
  </svg>
);
